/**
 * This module provides functions in relation to calling API routes on the backend server and processing the incoming
 * responses. The functions in this module refer to the API endpoint ApiEndPoints.PORTFOLIO_ROW.
 * @module
 */

import {ApiEndPoints, HttpMethods} from "../base/Settings";
import type {FetchRequest, PortfolioRowInput, PortfolioRow, UUID} from "../base/ui_general/GeneralInterfaces";


/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the creation of a new
 * portfolio_row on the server. Only name, description and portfolio_row type need to be specified for this purpose.
 * @param portfolio_rowInput An object of type PortfolioRowInput containing the input data for creating the portfolio_row.
 * @returns A FetchRequest object containing the generated fetch request.*/
export function getRequest_create_portfolio_row(portfolio_rowInput: PortfolioRowInput): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.PORTFOLIO_ROW,
        method: HttpMethods.POST,
        query_parameters: {},
        body: portfolio_rowInput,
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for updating an existing
 * portfolio_row on the server.
 * @param portfolio_row An object of type PortfolioRow containing the updated portfolio_row data.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_update_portfolio_row(portfolio_row: PortfolioRow): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.PORTFOLIO_ROW,
        method: HttpMethods.PUT,
        query_parameters: {},
        body: portfolio_row,
    };
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the query of portfolio_rows
 * on the server.
 * @param portfolio_id Optional. The UUID of the portfolio to query for.
 * @returns A FetchRequest object containing the generated fetch request.*/
export function getRequest_get_all_portfolio_rows(portfolio_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.PORTFOLIO_ROW,
        method: HttpMethods.GET,
        query_parameters: { portfolio_id: portfolio_id },
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for deleting an existing
 * portfolio_row on the server.
 * @param portfolio_row_id The UUID of the portfolio_row to delete.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_delete_portfolio_row(portfolio_row_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.PORTFOLIO_ROW,
        method: HttpMethods.DELETE,
        query_parameters: { portfolio_row_id: portfolio_row_id },
    };
}
